var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewPattern2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177.01 171.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d8d8d8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_3",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.76,32.54H93.7a0,0,0,0,1,0,0V139a0,0,0,0,1,0,0H17.76a2,2,0,0,1-2-2V34.54A2,2,0,0,1,17.76,32.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.87,32.54H160.5a2,2,0,0,1,2,2V137a2,2,0,0,1-2,2H105.87a0,0,0,0,1,0,0V32.54A0,0,0,0,1,105.87,32.54Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPattern2);
export default __webpack_public_path__ + "static/media/viewPattern2.4a3899b5b92476e08e6f494ce537a9f5.svg";
export { ForwardRef as ReactComponent };